import Calc from "@/common/util/calculator"
import BaseScrewFixmethod from "@/signomatic/app/fixmethods/base_screw"

export default class ScrewPlasticFixmethod extends BaseScrewFixmethod {
  positions() {
    const { shape, widthPx, width, heightPx, height } = this.state
    const positions = []
    const diameter = Calc.mmToPx(3)
    const cappedScrew = this.state.fixmethod === "screw_capped"
    const headDiameter = cappedScrew ? Calc.mmToPx(10) : Calc.mmToPx(5)
    let distance = 0
    let min = 0
    let max = 0

    const border = this.drawables.borderWidth
    const defaults = { diameter, headDiameter }

    if (["rect", "round"].includes(shape)) {
      // four screws
      if (height >= 100) {
        if (shape === "rect") {
          min = Calc.mmToPx(border ? 8 : 6)
          max = Calc.mmToPx(border ? 16.5 : 10)
        } else if (shape === "round") {
          min = Calc.mmToPx(border ? 10.5 : 8)
          max = Calc.mmToPx(border ? 18 : 18)
        }

        distance = this.drawables.sizeRelative("height", min, max, { minHeight: 100 })

        const left = border + distance - diameter / 2
        const top = border + distance - diameter / 2
        const right = widthPx - border - diameter / 2 - distance
        const bottom = heightPx - border - diameter / 2 - distance

        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
      } else {
        const centerV = heightPx / 2 - diameter / 2
        cappedScrew
          ? (distance = Calc.mmToPx(shape === "round" && border ? 8 : 6))
          : (distance = Calc.mmToPx(4.5) - border)

        positions.push({ ...defaults, left: border + distance - diameter / 2, top: centerV })
        positions.push({
          ...defaults,
          left: widthPx - distance - diameter / 2 - border,
          top: centerV,
        })
      }
    } else if (shape == "rotated_rect") {
      distance = cappedScrew
        ? this.drawables.sizeRelative("height", Calc.mmToPx(10), Calc.mmToPx(22))
        : this.drawables.sizeRelative("height", Calc.mmToPx(8), Calc.mmToPx(18))

      const centerV = heightPx / 2 - diameter / 2
      const left = distance - diameter / 2
      const right = widthPx - diameter / 2 - distance

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    } else if (["ellipse", "thorny", "stop"].includes(shape)) {
      if (shape === "ellipse") {
        min = Calc.mmToPx(6)
        max = Calc.mmToPx(border ? 13 : 9)
      } else if (shape === "thorny") {
        min = Calc.mmToPx(border ? 8 : 7.5)
        max = Calc.mmToPx(border ? 37 : 30)
      } else if (shape === "stop") {
        min = Calc.mmToPx(6)
        max = Calc.mmToPx(border ? 13 : 9)
      }

      const thornExtra = border ? this.thornDistance : 0
      distance = this.drawables.sizeRelative("height", min, max)

      const left = thornExtra + border + distance - diameter / 2
      const right = widthPx - thornExtra - border - diameter / 2 - distance
      const center = heightPx / 2 - diameter / 2

      positions.push({ ...defaults, left, top: center })
      positions.push({ ...defaults, left: right, top: center })
    } else if (["direction_left", "direction_right"].includes(shape)) {
      const distanceFront = cappedScrew
        ? this.drawables.sizeRelative("height", Calc.mmToPx(border ? 10 : 9), Calc.mmToPx(border ? 18 : 13))
        : this.drawables.sizeRelative("height", Calc.mmToPx(4.5), Calc.mmToPx(16))
      const distanceBack = cappedScrew
        ? this.drawables.sizeRelative("height", Calc.mmToPx(5.4), Calc.mmToPx(border ? 13 : 8))
        : this.drawables.sizeRelative("height", Calc.mmToPx(3.5), Calc.mmToPx(8))

      const centerV = heightPx / 2 - diameter / 2
      let left = distanceFront - diameter / 2
      let right = widthPx - diameter / 2 - distanceBack

      if (shape === "direction_right") {
        left = distanceBack - diameter / 2
        right = widthPx - diameter / 2 - distanceFront

        positions.push({
          ...defaults,
          left: widthPx - diameter / 2 - distanceBack,
          top: centerV,
          stretch: true,
        })
      } else {
        positions.push({
          ...defaults,
          left: distanceBack - diameter / 2,
          top: centerV,
          stretch: true,
        })
      }

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    } else if (shape === "arrow_left" || shape === "arrow_right") {
      const minFront = Calc.mmToPx(9)
      const maxFront = Calc.mmToPx(border ? 18 : 13)
      const minBack = Calc.mmToPx(5.4)
      const maxBack = Calc.mmToPx(border ? 13 : 8)

      const distanceFront = this.drawables.sizeRelative("height", minFront, maxFront)
      const distanceBack = this.drawables.sizeRelative("height", minBack, maxBack)

      let left = border + distanceFront - diameter / 2
      let right = widthPx - border - diameter / 2 - distanceBack
      const centerV = heightPx / 2 - diameter / 2

      if (shape === "arrow_right") {
        left = border + distanceBack - diameter / 2
        right = widthPx - border - diameter / 2 - distanceFront

        positions.push({
          ...defaults,
          left: widthPx - border - diameter / 2 - distanceBack,
          top: centerV,
          stretch: true,
        })
      } else {
        positions.push({
          ...defaults,
          left: border + distanceBack - diameter / 2,
          top: centerV,
          stretch: true,
        })
      }

      positions.push({ ...defaults, left, top: centerV })
      positions.push({ ...defaults, left: right, top: centerV })
    } else if (shape === "triangle") {
      min = Calc.mmToPx(5.5)
      max = Calc.mmToPx(border ? 13 : 9)
      distance = this.drawables.sizeRelative("height", min, max)

      const offset = Calc.triangleHorizontalOffset(widthPx, heightPx, distance)
      const minTop = Calc.mmToPx(12)
      const maxTop = Calc.mmToPx(border ? 28 : 14)
      const distanceTop = this.drawables.sizeRelative("height", minTop, maxTop)

      const center = widthPx / 2 - diameter / 2
      const top = distanceTop - diameter / 2
      const topStretch = distance - headDiameter / 2
      const bottom = heightPx - diameter / 2 - distance
      const left = offset + distance - diameter / 2
      const right = widthPx - offset - diameter / 2 - distance

      positions.push({ ...defaults, left: center, top })
      positions.push({ ...defaults, left, top: bottom })
      positions.push({ ...defaults, left: right, top: bottom })
      positions.push({ ...defaults, left: center, top: topStretch, stretch: true })
    } else if (["rounded_top", "rounded_sides", "curved_top", "arched_top"].includes(shape)) {
      let distanceSide = 0
      let distanceTop = 0

      const fourScrews = width >= 199
      const relOptions = { minWidth: 200, minHeight: 200 }
      if (cappedScrew) {
        if (fourScrews) {
          if (shape == "arched_top") {
            distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(8), Calc.mmToPx(10), relOptions)
          } else if ("rounded_top" == shape) {
            distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(8), Calc.mmToPx(10), relOptions)
            distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(30), Calc.mmToPx(40), relOptions)
          } else if ("rounded_sides" == shape) {
            distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(25), Calc.mmToPx(35), relOptions)
            distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(8), Calc.mmToPx(10), relOptions)
          } else if (shape == "curved_top") {
            distance = this.drawables.sizeRelative("width", Calc.mmToPx(8), Calc.mmToPx(10), relOptions)
            const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(48), Calc.mmToPx(120), {
              minWidth: 200,
              minHeight: 100,
            })

            const left = distance - diameter / 2
            const top = distance - diameter / 2
            const right = widthPx - distance - diameter / 2
            const bottom = heightPx - Calc.mmToPx(8) - diameter / 2

            positions.push({ ...defaults, left, top })
            positions.push({ ...defaults, left, top: bottom })
            positions.push({ ...defaults, left: right, top: curveTop })
            positions.push({ ...defaults, left: right, top: bottom })

            return positions
          }
        } else {
          distanceSide = Calc.mmToPx(8)
        }
      } else {
        if (fourScrews) {
          if (shape == "arched_top") {
            distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(6), Calc.mmToPx(8), relOptions)
          } else if ("rounded_top" == shape) {
            distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(6), Calc.mmToPx(8), relOptions)
            distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(30), Calc.mmToPx(40), relOptions)
          } else if ("rounded_sides" == shape) {
            distanceSide = this.drawables.sizeRelative("width", Calc.mmToPx(25), Calc.mmToPx(35), relOptions)
            distanceTop = this.drawables.sizeRelative("height", Calc.mmToPx(6), Calc.mmToPx(8), relOptions)
          } else if (shape == "curved_top") {
            distance = this.drawables.sizeRelative("width", Calc.mmToPx(6), Calc.mmToPx(8), relOptions)
            const curveTop = this.drawables.sizeRelative("height", Calc.mmToPx(43), Calc.mmToPx(120), {
              minWidth: 200,
              minHeight: 100,
            })

            const left = distance - diameter / 2
            const top = distance - diameter / 2
            const right = widthPx - distance - diameter / 2
            const bottom = heightPx - Calc.mmToPx(6) - diameter / 2

            positions.push({ ...defaults, left, top })
            positions.push({ ...defaults, left, top: bottom })
            positions.push({ ...defaults, left: right, top: curveTop })
            positions.push({ ...defaults, left: right, top: bottom })

            return positions
          }
        } else {
          distanceSide = Calc.mmToPx(6)
        }
      }

      let left = distanceSide - diameter / 2
      let top = distanceTop - diameter / 2
      let bottom = heightPx - distanceTop - diameter / 2
      let right = widthPx - distanceSide - diameter / 2
      let centerV = widthPx / 2 - diameter / 2

      if (shape == "arched_top") {
        // arcH constant also in arched_top
        const arcH = heightPx * 0.35

        if (fourScrews) {
          const fromEdge = distanceSide + diameter / 2
          top = arcH + fromEdge
          bottom = heightPx - fromEdge
          left = fromEdge
          right = widthPx - fromEdge

          positions.push({
            ...defaults,
            left: widthPx / 2 - diameter / 2,
            top: fromEdge - diameter,
            stretch: true,
          })

          positions.push({
            ...defaults,
            left: widthPx / 2 - diameter / 2,
            top: heightPx - fromEdge / 2 - diameter,
            stretch: true,
          })
        } else {
          const squareHeight = heightPx - arcH
          centerV = arcH + squareHeight / 2 - diameter / 2
          const heightDiff = cappedScrew ? diameter * 2.1 : diameter
          positions.push({
            ...defaults,
            left: widthPx / 2 - diameter / 2,
            top: heightPx - centerV - heightDiff,
            stretch: true,
          })
        }
      }

      if (fourScrews) {
        positions.push({ ...defaults, left, top })
        positions.push({ ...defaults, left, top: bottom })
        positions.push({ ...defaults, left: right, top })
        positions.push({ ...defaults, left: right, top: bottom })
      } else {
        positions.push({ ...defaults, left, top: centerV })
        positions.push({ ...defaults, left: right, top: centerV })
      }
    }

    return positions
  }
}
